








import { Component, Mixins, Prop } from "vue-property-decorator";
import { ModelEditableMixin } from "../mixins";
import {
  IMultiSelectableAsynchronously,
  instanceOfIMultiSelectableConditionallyAsynchronously,
} from ".";

@Component({
  components: {
  },
})
export default class MultiDialogSelector extends Mixins(ModelEditableMixin) {
  editingSource: any[];

  @Prop()
  dialog: IMultiSelectableAsynchronously<any>;

  @Prop({ default: false })
  isClearable: boolean;

  @Prop({ default: "選択" })
  labelOfSelect: string;

  @Prop({ default: "クリア" })
  labelOfClear: string;

  @Prop()
  format: (s: any[]) => string;

  @Prop()
  condition: any;

  get labelOfSelectedOption(): string {
    return !this.format
      ? (!this.editingSource ? "" : this.editingSource.join(","))
      : this.format(this.editingSource);
  }

  get isSelectable(): boolean {
    return !!this.dialog;
  }

  select(): void {
    this.selectOptions()
      .then(o => {
        if (o !== undefined) {  // undefinedの時はキャンセル.
          this.editingSource = o;
        }
      });
  }

  selectOptions(): Promise<any[]> {
    if (instanceOfIMultiSelectableConditionallyAsynchronously<any, any>(this.dialog)) {
      return this.dialog.selectOptionsConditionally(this.condition, this.editingSource);
    } else {
      return this.dialog.selectOptions(this.editingSource);
    }
  }

  clear(): void {
    this.editingSource = null;
  }
}
